import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={9}
    height={12}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M0 1.433C0 .642.63 0 1.406 0h6.188C8.37 0 9 .642 9 1.433V12L4.5 8.728 0 12V1.433Zm1.406-.287a.283.283 0 0 0-.281.287v8.344L4.5 7.318l3.375 2.459V1.433a.283.283 0 0 0-.281-.287H1.406Z"
    />
  </svg>
)
export default SvgComponent
